<template>
    <div class="container my-2">
    <b-alert
      v-model="showTop"
      class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000;"
      variant="secondary"
    >
      {{message}}
    </b-alert>
        <div class="d-flex">
            <img src="@/assets/Icon/schedule list.svg" width="70"/>
            <h3 class="textmargin">LIST JADWAL DOKTER & PERAWAT</h3>
        </div>
        <div class="col-12">          
            <b-button class="btn btn-info text-black" @click="addJadwal()">TAMBAH JADWAL <b-icon icon="plus"></b-icon></b-button>
        </div>
        <div class="d-block">
            <b-card bg-variant="light" class="card text-center mx-2 my-2 text-purple">
            <div class="d-flex">
            <p class="m-0 p-2">Tanggal</p>
            <b-form-datepicker id="example-datepicker" v-model="values" class="mb-2 hdrop"></b-form-datepicker>
            </div>
                        <ul class="list-group list-group-light" v-for="schedule in searchItem" :key="schedule.id">
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            <div class="text-align-left">
                            <div class="fw-bold">{{schedule.nurse_table.name}}</div>
                            <div class="text-muted">PERAWAT</div>
                            </div>
                            <span class="">{{schedule.date}}</span>
                        </li>
                        </ul>
                        <ul class="list-group list-group-light" v-for="schedule in searchItem" :key="schedule.id">
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            <div class="text-align-left">
                            <div class="fw-bold">{{schedule.doctor_table.name}}</div>
                            <div class="text-muted">DOKTER {{schedule.doctor_table.medic_facility.name.toUpperCase()}}</div>
                            </div>
                            <span class="">{{schedule.session.name.toUpperCase()}} : {{schedule.session.time}}</span>
                        </li>
                        </ul>
            </b-card>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    name: 'scheduleList',
    computed: {
        searchItem(){              
        const filter = this.values
              ? this.items.filter(item => item.date.includes(this.values))
              : this.listItem
              return filter
      },
       listItem() {
                    return this.items.slice(
                    (this.currentPage - 1) * this.perPage,
                    this.currentPage * this.perPage,
              )
       }
    },


    data() {
      return {
        values: '',
        showTop: false,
        message: '',
        items: [],
        
      }
    },
    
    methods: {
      addJadwal() {
          this.$router.push('/addschedule');
        },

    },
   async mounted() {
        const message = this.$localStorage.get('messageSchedule')
       if(message){
          this.message = message
               this.showTop = true
              setTimeout(() => {
            this.showTop = false;
            localStorage.removeItem('messageSchedule');
                  }, 3000);
       }
        try {
              const response = await axios.get('schedule');
            this.items = response.data.schedule;
              console.log(response.data)
            } catch(e) {
              console.log(e);
            }
            console.log(this.searchItem)

    },
}
</script>

<style scoped>

.text-align-left{
    text-align: left;
}

.lightdark-a {
  background-color: #DDDDDD;
;

;
}
.lightdark-b {
background-color: #F3F3F3;

;
}

.hdrop {
  height: 38px;
  margin-top: 5px;
  margin-bottom: 5px;
 border-radius: 5px; 
 border: 1px solid #1b1515;
 background: #F3F3F3;
}

.textmargin {
    margin-top: 20px;
}
.ddown {
    justify-items: end;
    justify-content: end;
    display: flex;
}
.cardlist{
    padding: 15px;
    margin: 5px;
    background-color:white;
;
    display: flex;
    justify-content: space-between;
}
</style>